import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import {
    namespace,
    translations,
} from "../../mytrumpf/page-templates/my-machines/my-machines-detail/tabs/trainings";
import { addI18nTranslations } from "../../utils";

export default {
    title: "Components/Stateful Filter & Content/Stateful Content/Stateful Trainings",
    parameters: {
        docs: { source: { transform: formatHtml } },
        forceRender: true,
    },
    component: "ux-iws-stateful-trainings",
    args: { scope: "", url: "" },
    argTypes: {
        scope: { control: "text" },
        translations: { control: "Translations | string" },
        url: { control: "text" },
    },
};

const language = "de-DE";

addI18nTranslations({ namespace, translations, language });

const Template = () => {
    return html`
        <div class="ux-row">
            <div class="ux-col-12">
                <ux-iws-stateful-trainings
                    scope="${namespace}"
                    url="./generated-mock-data/mymachine-trainings-content.json"
                    translations-namespace="${namespace}"
                    language="${language}"
                ></ux-iws-stateful-trainings>
            </div>
        </div>
        ${TrainingFooter()}
    `;
};

const TemplateWithFilter = ({ withTags }) => {
    return html`
        <div class="ux-row">
            <div class="ux-col-12">
                <ux-iws-stateful-filter
                    scope="${namespace}"
                    url="./generated-mock-data/mymachine-trainings-filter.json"
                    disable-tags
                ></ux-iws-stateful-filter>
            </div>
            ${withTags
                ? html` <div class="ux-col-12">
                      <ux-iws-stateful-filter-tags
                          language="${language}"
                          scope="${namespace}"
                      ></ux-iws-stateful-filter-tags>
                  </div>`
                : ""}
        </div>
        <div class="ux-row">
            <div class="ux-col-12">
                <hr class="ux-u-d-block ux-u-mt-zero ux-u-mb-xs" />
            </div>
        </div>
        <div class="ux-row">
            <div class="ux-col-12">
                <ux-iws-stateful-trainings
                    scope="${namespace}"
                    url="./generated-mock-data/mymachine-trainings-content.json"
                    translations-namespace="${namespace}"
                    language="${language}"
                ></ux-iws-stateful-trainings>
            </div>
        </div>
        ${TrainingFooter()}
    `;
};

const TemplateEmpty = () => {
    return html`
        <div class="ux-row">
            <div class="ux-col-12">
                <ux-iws-stateful-trainings
                    scope="${namespace}"
                    url="./generated-mock-data/mymachine-trainings-empty.json"
                    translations-namespace="${namespace}"
                    language="${language}"
                ></ux-iws-stateful-trainings>
            </div>
        </div>
        ${TrainingFooter()}
    `;
};

const TrainingFooter = () => {
    return html`
        <div class="ux-row">
            <div class="ux-col-12 ux-u-mb-l ux-u-mt-xl">
                <div class="ux-u-shadow">
                    <div class="ux-iws-teaser-content--segmentation-1-2 ">
                        <div class="ux-iws-teaser-content__image-wrapper">
                            <picture>
                                <source
                                    src="./mock-assets/images/mytrumpf/my-machines-no-trainings.jpg"
                                />
                                <img
                                    src="./mock-assets/images/mytrumpf/my-machines-no-trainings.jpg"
                                    alt="my-machines-no-trainings"
                                />
                            </picture>
                        </div>
                        <div class="ux-iws-teaser-content__content">
                            <h2
                                class="ux-text-headline ux-text-headline--big ux-u-mt-zero ux-u-mb-xxs"
                            >
                                TRUMPF Lorem ipsum dolor sit amet
                            </h2>
                            <p class="ux-text-normal ux-u-mb-xs">
                                Lorem ipsum dolor sit amet, consetetur
                                sadipscing elitr, sed diam nonumy eirmod tempor
                                invidunt ut labore et dolore magna aliquyam
                                erat, sed diam voluptua. At vero eos et accusam
                                et justo duo dolores et ea rebum. Stet clita
                                kasd gubergren, no sea takimata sanctus.
                            </p>
                            <a class="ux-button" href="#">mehr erfahren</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="ux-col-12">
                <a href="#" class="ux-button" title="back">
                    <ux-icon name="chevron-left" class="ux-icon"></ux-icon>
                    Zurück
                </a>
            </div>
        </div>
    `;
};

export const Default = Template.bind({});
Default.namespace = namespace;
Default.translations = translations;

export const WithFilter = TemplateWithFilter.bind({});

export const WithFilterAndTags = TemplateWithFilter.bind({});
WithFilterAndTags.args = { withTags: true };

export const Empty = TemplateEmpty.bind({});
